const tableMixin = {
  /**
   * @fetchItemsUrl: handles api-url, items
   * @search: handles b-table filter
   * @meta: fetchItemsUrl.meta (pagination)
   * @currentPage: handles b-table, b-pagination currentPage
   **/
  data: () => ({
    search: '',
    meta: null,
    currentPage: 1,
    filters: [],
    currentAbortController: null,
  }),

  computed: {
    /**
     * @returns {String} fetchItemsUrl
     * @description in case the string has parameters and therefore cannot be initialized in data
     **/
    fetchItemsUrl () { return this.fetchItemsUrl },

    /**
     * @returns {{total: *, perPage: *, totalRows: number, currentPage: number}}
     * @description to handle b-pagination and b-table correctly
     **/
    pagination () {
      return {
        totalRows: this.meta?.last_page * this.meta?.per_page,
        perPage: this.meta?.per_page,
        currentPage: this.currentPage,
        total: this.meta?.total
      }
    }
  },

  methods: {
    /**
     * @param {{currentPage: number, filter: String, sortBy: String, sortDesc: String}}
     * @description Table state context object.
     **/
    async items ({ currentPage, filter, sortBy, sortDesc, additionalFilters = '' }) {
      try {
        this.currentAbortController = new AbortController()
        const operator = this.fetchItemsUrl.match(/\?./) ? '&' : '?'
        const orderBy = sortDesc ? 'desc' : 'asc'
        const baseUrls = `${this.fetchItemsUrl}${operator}page=${currentPage}&search=${filter}&order-by=${sortBy}&order-dir=${orderBy}`
        const url = additionalFilters ? `${baseUrls}&${additionalFilters}` : baseUrls
        const res = await this.$axios.get(url, {signal: this.currentAbortController.signal})
        this.filters = res.filters
        this.meta = res.meta
        this.currentAbortController = null
        return res.data || []
      } catch {
        // Todo: retry
        return []
      }
    }
  }
}
export default tableMixin
